import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

/** Desktop shell at >= lg (1200px); the compact shell below (CNPWKS-0003 C3). */
export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
}
